module.exports = __webpack_public_path__ + "media/images/lp_v6_img07-f8b46cf68dd11083f6883dfbc18a00bf.webp";